
import Sum from "../../components/Summary/Sum";


function About(){
    return(
        
        //merender dari react-router
        <div>
            <h4>Tugas UAS FrontEnd Covid-19</h4>
            <h4>Andika Alifian</h4>
            <Sum />
            
            
            
            
        </div>
    )
}

export default About;